import { render, staticRenderFns } from "./ProductDetail3.vue?vue&type=template&id=1d57c5f0&scoped=true"
import script from "./ProductDetail3.vue?vue&type=script&lang=js"
export * from "./ProductDetail3.vue?vue&type=script&lang=js"
import style0 from "./ProductDetail3.vue?vue&type=style&index=0&id=1d57c5f0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d57c5f0",
  null
  
)

export default component.exports